import { Dialog, DialogContent, Box, Button, IconButton } from '@mui/material';
import PioneerContent from './PioneerContent';

const STORAGE_KEY = 'inorai_pioneer_popup_seen';

const PioneerPopup = ({ open, onClose, onOpenModal }) => {
  const handleClose = () => {
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) { /* private browsing */ }
    onClose();
  };

  const handleCta = () => {
    handleClose();
    onOpenModal?.('contact', {
      planName: 'נֵר — תכנית חלוצים',
      subject: 'הצטרפות לתכנית החלוצים',
      message: 'שלום,\nאני מעוניין/ת להצטרף לתכנית החלוצים של inorai — מסלול נֵר.\n\nפרטים נוספים:\n',
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          direction: 'rtl',
          borderRadius: 3,
          background: 'linear-gradient(135deg, #1a3352 0%, #243f5f 40%, #2a4a6a 70%, #1e3a5f 100%)',
          border: '2px solid rgba(184,134,11,0.45)',
          maxHeight: '90vh',
          m: { xs: 1.5, sm: 3 },
          overflow: 'hidden',
          position: 'relative',
        },
      }}
    >
      {/* Warm radial glow */}
      <Box sx={{
        position: 'absolute',
        inset: 0,
        background: 'radial-gradient(ellipse at 40% 20%, rgba(184,134,11,0.18) 0%, rgba(251,191,36,0.06) 40%, transparent 70%)',
        pointerEvents: 'none',
      }} />

      {/* Close button */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          top: 12,
          left: 12,
          zIndex: 2,
          color: 'rgba(255,255,255,0.5)',
          '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.1)' },
        }}
      >
        <Box component="span" sx={{ fontSize: '1.1rem', lineHeight: 1 }}>✕</Box>
      </IconButton>

      <DialogContent sx={{ px: { xs: 3, sm: 4 }, py: { xs: 1, sm: 1.5 }, position: 'relative', zIndex: 1 }}>
        <PioneerContent compact />

        {/* CTA buttons */}
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, mt: 3 }}>
          <Button
            variant="contained"
            onClick={handleCta}
            sx={{
              bgcolor: '#9a7209',
              color: 'white',
              fontFamily: 'Heebo, sans-serif',
              fontWeight: 700,
              fontSize: '0.95rem',
              py: 1.3,
              px: 3.5,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(154,114,9,0.45)',
              '&:hover': {
                bgcolor: '#b8860b',
                boxShadow: '0 10px 30px rgba(154,114,9,0.55)',
              },
              transition: 'all 0.25s ease',
              flex: { sm: 1 },
            }}
          >
            אני רוצה להצטרף
          </Button>
          <Button
            variant="text"
            onClick={handleClose}
            sx={{
              color: 'rgba(255,255,255,0.5)',
              fontFamily: 'Heebo, sans-serif',
              fontWeight: 500,
              fontSize: '0.85rem',
              py: 1.3,
              borderRadius: 2,
              '&:hover': { color: 'rgba(255,255,255,0.8)', bgcolor: 'rgba(255,255,255,0.05)' },
            }}
          >
            לא עכשיו
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export { STORAGE_KEY };
export default PioneerPopup;
